module.exports = __webpack_public_path__ + "img/celebrate-mobile.54e0988d.jpg";